export default __webpack_public_path__ + "static/media/Fire.c580edc5.svg";